/**
 * Event topics are stored as translated English strings in the DB. So,
 * until this is fixed, we need an extra layer of translation to allow
 * us to switch from English key -> internal i18n key and back
 *
 * See: https://timedright.jira.com/browse/TRAPP-1785
 */

// NOTE: See below for additional exports
export const EVENT_TOPIC_KEYS_TO_API_STRING: Record<string, string> = {
	'event.category.abdominal': 'Abdominal',
	'event.category.academic-pharmacist': 'Academic Pharmacist',
	'event.category.acne-treatment': 'Acne Treatment',
	'event.category.acquired-brain-injury': 'Acquired Brain Injury',
	'event.category.acupuncture': 'Acupuncture',
	'event.category.addiction-medicine-acupuncture': 'Addiction Medicine',
	'event.category.addiction-services': 'Addiction Services',
	'event.category.administration': 'Administration',
	'event.category.administrative-medicine': 'Administrative Medicine',
	'event.category.administrative-support': 'Administrative Support',
	'event.category.adult-congenital-heart-disease': 'Adult Congenital Heart Disease',
	'event.category.adult-education': 'Adult Education',
	'event.category.adult-general-psychiatry': 'Adult General Psychiatry',
	'event.category.advanced-practice': 'Advanced practice',
	'event.category.advocacy-issue-management': 'Advocacy/Issue Management',
	'event.category.aids-hiv': 'AIDS/HIV',
	'event.category.allergy': 'Allergy',
	'event.category.allied-health': 'Allied Health',
	'event.category.alternative-medicine': 'Alternative Medicine',
	'event.category.ambulatory-pharmacist': 'Ambulatory Pharmacist',
	'event.category.anaesthesia': 'Anaesthesia',
	'event.category.anatomical-pathology': 'Anatomical Pathology',
	'event.category.andrology': 'Andrology',
	'event.category.arthroplasty': 'Arthroplasty',
	'event.category.arts-recreational-therapy': 'ArtsRecreational Therapy',
	'event.category.asthma-and-allergy': 'Asthma and Allergy',
	'event.category.attention-deficit-hyperactivity-disorder': 'Attention Deficit Hyperactivity Disorder',
	'event.category.aviation': 'Aviation',
	'event.category.bacteriology': 'Bacteriology',
	'event.category.behavioral-health': 'Behavioral health',
	'event.category.behaviour-and-development': 'Behaviour and Development',
	'event.category.behaviour-and-learning': 'Behaviour and Learning',
	'event.category.biotechnology': 'Biotechnology',
	'event.category.bone-marrow-transplant': 'Bone Marrow Transplant',
	'event.category.botox-injection': 'Botox Injection',
	'event.category.brain-injury-psychiatry': 'Brain Injury Psychiatry',
	'event.category.breast-cancer': 'Breast Cancer',
	'event.category.breast-disease': 'Breast Disease',
	'event.category.cardiac': 'Cardiac',
	'event.category.cardiac-catheter-laboratory': 'Cardiac catheter laboratory',
	'event.category.cardiac-rehabilitation': 'Cardiac Rehabilitation',
	'event.category.cardiac-surgery': 'Cardiac Surgery',
	'event.category.cardiology': 'Cardiology',
	'event.category.cardiothoracic-surgery': 'Cardiothoracic  Surgery',
	'event.category.cardiovascular-and-thoracic-surgery': 'Cardiovascular and Thoracic Surgery',
	'event.category.case-management': 'Case management',
	'event.category.cataract-surgery': 'Cataract Surgery',
	'event.category.certified-diabetes-educator': 'Certified Diabetes Educator',
	'event.category.child-abuse': 'Child Abuse',
	'event.category.child-and-youth-worker': 'Child and Youth Worker',
	'event.category.child-adolescent-stress': 'Child, Adolescent Stress',
	'event.category.chronic-pain': 'Chronic Pain',
	'event.category.chronic-pain-management': 'Chronic Pain Management',
	'event.category.clinical-immunology': 'Clinical Immunology',
	'event.category.clinical-immunology-and-allergy': 'Clinical Immunology and Allergy',
	'event.category.clinical-management': 'Clinical Management',
	'event.category.clinical-nurse-specialist': 'Clinical nurse specialist',
	'event.category.clinical-pathology': 'Clinical Pathology (P.Q.)',
	'event.category.clinical-pharmacist': 'Clinical Pharmacist',
	'event.category.clinical-research': 'Clinical research',
	'event.category.clinical-standards-practice-guidelines': 'Clinical Standards/Practice Guidelines',
	'event.category.clinics-practices': 'Clinics & Practices',
	'event.category.cognitive-behaviour-therapy': 'Cognitive Behaviour Therapy',
	'event.category.cognitive-neurol': 'Cognitive Neurol',
	'event.category.communications': 'Communications',
	'event.category.community-development': 'Community Development',
	'event.category.community-health': 'Community health',
	'event.category.community-medicine': 'Community Medicine',
	'event.category.conference-planning': 'Conference Planning',
	'event.category.contracting-and-outsourcing': 'Contracting and Outsourcing',
	'event.category.cooking-classes-food-demonstrations': 'Cooking Classes/Food Demonstrations',
	'event.category.cornea': 'Cornea',
	'event.category.corporate-health': 'Corporate Health',
	'event.category.corporate-health-and-wellness-programs': 'Corporate Health and Wellness Programs',
	'event.category.corporate-partnerships': 'Corporate Partnerships',
	'event.category.correctional': 'Correctional',
	'event.category.critical-care': 'Critical Care',
	'event.category.crohns-disease': 'Crohns Disease',
	'event.category.custody-and-access': 'Custody and Access',
	'event.category.dental': 'Dental',
	'event.category.dermatology': 'Dermatology',
	'event.category.developmental-disabilities': 'Developmental disabilities',
	'event.category.diabetes': 'Diabetes',
	'event.category.diabetes-nurse-educator': 'Diabetes Nurse Educator',
	'event.category.diabetology': 'Diabetology',
	'event.category.diagnostic-equipment-company': 'Diagnostic Equipment Company',
	'event.category.diagnostic-radiology': 'Diagnostic Radiology',
	'event.category.diagnostic-service-provider': 'Diagnostic Service provider',
	'event.category.dietary-assessment': 'Dietary Assessment',
	'event.category.dietary-intake-survey-methods': 'Dietary Intake Survey Methods',
	'event.category.digestive-endoscopy': 'Digestive Endoscopy',
	'event.category.disability-evaluation': 'Disability Evaluation',
	'event.category.disability-management-and-rehabilitation': 'Disability Management and Rehabilitation',
	'event.category.distance-web-based-education': 'Distance/Web Based Education',
	'event.category.diving-medicine': 'Diving Medicine',
	'event.category.drug-safety': 'Drug Safety',
	'event.category.eating-disorders': 'Eating Disorders',
	'event.category.education': 'Education',
	'event.category.education-program-assistant': 'Education Program Assistant',
	'event.category.educational-institute': 'Educational Institute',
	'event.category.electophysiology': 'Electophysiology',
	'event.category.electroencephal': 'Electroencephal',
	'event.category.electrophysiology': 'Electrophysiology',
	'event.category.emergency': 'Emergency',
	'event.category.emergency-family-medicine': 'Emergency Family Medicine',
	'event.category.emergency-medicine': 'Emergency Medicine',
	'event.category.endocrinology': 'Endocrinology',
	'event.category.endocrinology-and-metabolism': 'Endocrinology and Metabolism',
	'event.category.endocrinology-pathology': 'Endocrinology Pathology',
	'event.category.environmental-health': 'Environmental Health',
	'event.category.environmental-medicine': 'Environmental Medicine',
	'event.category.epidemiology': 'Epidemiology',
	'event.category.epilepsy': 'Epilepsy',
	'event.category.executive-direction': 'Executive Direction',
	'event.category.external-eye-disease': 'External Eye Disease',
	'event.category.facilitation': 'Facilitation',
	'event.category.family-health-teams': 'Family Health Teams',
	'event.category.family-health-unit': 'Family Health Unit',
	'event.category.family-medicine': 'Family Medicine',
	'event.category.fibromyalgia': 'Fibromyalgia',
	'event.category.finance': 'Finance',
	'event.category.food-and-nutrient-analysis': 'Food and Nutrient Analysis',
	'event.category.foodservice-distribution-sales': 'Foodservice Distribution/Sales',
	'event.category.foodservice-management': 'Foodservice Management',
	'event.category.foodservice-menu-development': 'Foodservice Menu Development',
	'event.category.foodservice-systems-design': 'Foodservice Systems Design',
	'event.category.forensic': 'Forensic',
	'event.category.forensic-and-neuro-pathology': 'Forensic and Neuro Pathology',
	'event.category.forensic-medicine': 'Forensic Medicine',
	'event.category.forensic-pathology': 'Forensic Pathology',
	'event.category.forensic-psychiatry': 'Forensic Psychiatry',
	'event.category.fundraising': 'Fundraising',
	'event.category.funds-development': 'Funds Development',
	'event.category.gastroenterology': 'Gastroenterology',
	'event.category.gastrointestinal-cancer': 'Gastrointestinal Cancer',
	'event.category.gastrointestinal-motility': 'Gastrointestinal Motility',
	'event.category.gastrointestinal-radiology': 'Gastrointestinal Radiology',
	'event.category.gay-and-lesbian-issues': 'Gay and Lesbian Issues',
	'event.category.general-adult-psychiatry': 'General Adult Psychiatry',
	'event.category.general-medicine': 'General Medicine',
	'event.category.general-pathology': 'General Pathology',
	'event.category.general-practice': 'General Practice',
	'event.category.general-surgery': 'General Surgery',
	'event.category.genetics': 'Genetics',
	'event.category.geriatric-care': 'Geriatric Care',
	'event.category.geriatric-medicine': 'Geriatric Medicine',
	'event.category.gerontology': 'Gerontology',
	'event.category.government-regulatory': 'Government & Regulatory',
	'event.category.government-pharmacists': 'Government Pharmacists',
	'event.category.government-relations': 'Government Relations',
	'event.category.grant-proposal-writing': 'Grant/Proposal Writing',
	'event.category.grocery-store-nutrition-tours': 'Grocery Store/Nutrition Tours',
	'event.category.group-counselling': 'Group Counselling',
	'event.category.gynecological-oncology': 'Gynecological Oncology',
	'event.category.gynecological-surgery': 'Gynecological Surgery',
	'event.category.gynecology': 'Gynecology',
	'event.category.haematological-pathology': 'Haematological Pathology',
	'event.category.haematology': 'Haematology',
	'event.category.hair-transplantation': 'Hair Transplantation',
	'event.category.headache': 'Headache',
	'event.category.health-and-safety': 'Health and Safety',
	'event.category.health-care-analysis': 'Health Care Analysis',
	'event.category.health-promotion': 'Health Promotion',
	'event.category.health-sciences': 'Health Sciences',
	'event.category.health-services-administration': 'Health Services Administration',
	'event.category.health-visiting': 'Health visiting',
	'event.category.healthcare-consultant': 'Healthcare Consultant',
	'event.category.heart-failure': 'Heart Failure',
	'event.category.hematology': 'Hematology',
	'event.category.hematology-oncology': 'Hematology oncology',
	'event.category.hematology-pathology': 'Hematology Pathology',
	'event.category.hemostasis': 'Hemostasis',
	'event.category.herniology': 'Herniology',
	'event.category.hips-surgery': 'Hips Surgery',
	'event.category.home-care-pharmacist': 'Home Care Pharmacist',
	'event.category.home-health-care': 'Home Health Care',
	'event.category.hospice': 'Hospice',
	'event.category.hospital': 'Hospital',
	'event.category.hospital-pharmacist': 'Hospital Pharmacist',
	'event.category.human-resources': 'Human Resources',
	'event.category.hyperbaric-medicine': 'Hyperbaric Medicine',
	'event.category.hyperbaric-oxygen-therapist': 'Hyperbaric Oxygen Therapist',
	'event.category.hypnosis': 'Hypnosis',
	'event.category.immune-deficiency': 'Immune Deficiency',
	'event.category.immunology': 'Immunology',
	'event.category.independent-pharmacist': 'Independent Pharmacist',
	'event.category.individual-private-counselling': 'Individual/Private Counselling',
	'event.category.industrial-medicine': 'Industrial Medicine',
	'event.category.industrial-occupational-medicine': 'Industrial Occupational Medicine',
	'event.category.industrial-pharma-industry-pharmacist': 'Industrial/Pharma Industry Pharmacist',
	'event.category.infectious-diseases': 'Infectious Diseases',
	'event.category.information-systems': 'Information Systems',
	'event.category.information-technology': 'Information Technology',
	'event.category.insurance': 'Insurance',
	'event.category.insurance-medicine': 'Insurance Medicine',
	'event.category.intensive-care-unit': 'Intensive Care Unit (ICU)',
	'event.category.internal-medicine': 'Internal Medicine',
	'event.category.intravenous-therapy': 'Intravenous therapy',
	'event.category.laboratory-medicine': 'Laboratory Medicine',
	'event.category.labour-relations': 'Labour Relations',
	'event.category.laparoscopic-surgery': 'Laparoscopic Surgery',
	'event.category.laser-cosmetic-surgery': 'Laser Cosmetic Surgery',
	'event.category.laser-dermatology': 'Laser Dermatology',
	'event.category.law-ethics': 'Law & Ethics',
	'event.category.legal': 'Legal',
	'event.category.legal-nurse-investigator': 'Legal Nurse Investigator',
	'event.category.liver-disease': 'Liver Disease',
	'event.category.liver-transplant': 'Liver Transplant',
	'event.category.logistics-systems': 'Logistics & Systems',
	'event.category.long-term-care-and-rehabilitation': 'Long Term Care and Rehabilitation',
	'event.category.lung': 'Lung',
	'event.category.mammography': 'Mammography',
	'event.category.managed-care': 'Managed Care',
	'event.category.managed-care-pharmacist': 'Managed Care Pharmacist',
	'event.category.marketing': 'Marketing',
	'event.category.massage-therapy': 'Massage Therapy',
	'event.category.maternal-child': 'Maternal-child',
	'event.category.matron': 'Matron',
	'event.category.media-public-relations-communications': 'Media/Public Relations/Communications',
	'event.category.medical-biochemistry': 'Medical Biochemistry',
	'event.category.medical-computer-specialists': 'Medical Computer Specialists',
	'event.category.medical-equipment': 'Medical Equipment',
	'event.category.medical-genetics': 'Medical Genetics',
	'event.category.medical-laboratory': 'Medical Laboratory',
	'event.category.medical-legal-claim': 'Medical Legal Claim',
	'event.category.medical-microbiology': 'Medical Microbiology',
	'event.category.medical-office-assistant': 'Medical Office Assistant',
	'event.category.medical-oncology': 'Medical Oncology',
	'event.category.medical-publishers': 'Medical Publishers',
	'event.category.medical-receptionist-front-desk': 'Medical ReceptionistFront Desk',
	'event.category.medical-records': 'Medical Records',
	'event.category.medical-scientist': 'Medical Scientist',
	'event.category.medical-writer': 'Medical Writer',
	'event.category.medical-surgical': 'Medical-surgical',
	'event.category.medico-legal-assessments': 'Medico Legal Assessments',
	'event.category.membership-management': 'Membership Management',
	'event.category.mental-healthcare': 'Mental Healthcare',
	'event.category.mentoring-coaching': 'Mentoring/Coaching',
	'event.category.military-and-uniformed-services': 'Military and uniformed services nursing, including Public Health Service',
	'event.category.mood-disorders': 'Mood Disorders',
	'event.category.muscoloskeletal-medicine': 'Muscoloskeletal Medicine',
	'event.category.musculoskeletal-injury': 'Musculoskeletal Injury',
	'event.category.musculoskeletal-rehabilitation': 'Musculoskeletal Rehabilitation',
	'event.category.natural-healing': 'Natural Healing',
	'event.category.neonatal': 'Neonatal',
	'event.category.neonatology': 'Neonatology',
	'event.category.nephrology': 'Nephrology',
	'event.category.neuro-toxicology': 'Neuro Toxicology',
	'event.category.neurology': 'Neurology',
	'event.category.neurology-and-psychiatry': 'Neurology and Psychiatry',
	'event.category.neuropathology': 'Neuropathology',
	'event.category.neurosurgery': 'Neurosurgery',
	'event.category.newborn-medicine': 'Newborn Medicine',
	'event.category.not-for-profit': 'Not-for-profit Foundations & Associations',
	'event.category.nuclear-medicine': 'Nuclear Medicine',
	'event.category.nuclear-pharmacist': 'Nuclear Pharmacist',
	'event.category.nurse-anesthetist': 'Nurse anesthetist',
	'event.category.nurse-practitioner': 'Nurse practitioner',
	'event.category.nurse-midwife': 'Nurse-midwife',
	'event.category.nursing-administration': 'Nursing Administration',
	'event.category.nursing-educator': 'Nursing educator',
	'event.category.nursing-management': 'Nursing management',
	'event.category.nutrition-screening-assessment': 'Nutrition Screening/Assessment',
	'event.category.nutrition-software-and-databases': 'Nutrition Software and Databases',
	'event.category.obesity': 'Obesity',
	'event.category.obesity-management': 'Obesity Management',
	'event.category.obstetrics': 'Obstetrics',
	'event.category.obstetrics-and-gynaecology': 'Obstetrics and Gynaecology',
	'event.category.occupational-and-environmental-medicine': 'Occupational and Environmental Medicine',
	'event.category.occupational-health': 'Occupational health',
	'event.category.occupational-medicine': 'Occupational Medicine',
	'event.category.occupational-therapy': 'Occupational Therapy',
	'event.category.oncology': 'Oncology',
	'event.category.operating-room': 'Operating room',
	'event.category.operations': 'Operations',
	'event.category.ophthalmology': 'Ophthalmology',
	'event.category.organization-management-change': 'Organization Management/Change',
	'event.category.orthopedic': 'Orthopedic',
	'event.category.orthopedic-consultant': 'Orthopedic Consultant',
	'event.category.orthopedic-surgery': 'Orthopedic Surgery',
	'event.category.osteoporosis': 'Osteoporosis',
	'event.category.ostomy': 'Ostomy',
	'event.category.otolaryngology': 'Otolaryngology',
	'event.category.outreach-services': 'Outreach Services',
	'event.category.paediatric': 'Paediatric',
	'event.category.paediatric-pediatric-cardiology': 'Paediatric / Pediatric Cardiology',
	'event.category.paediatric-pediatric-surgery': 'Paediatric / Pediatric Surgery',
	'event.category.pain-control': 'Pain Control',
	'event.category.pain-management': 'Pain Management',
	'event.category.palliative-care': 'Palliative Care',
	'event.category.partnering': 'Partnering',
	'event.category.pathology': 'Pathology',
	'event.category.pathology-and-bacteriology': 'Pathology and Bacteriology',
	'event.category.pediatric-cardiology': 'Pediatric Cardiology',
	'event.category.pediatric-gastroenterology': 'Pediatric Gastroenterology',
	'event.category.pediatric-infectious-diseases': 'Pediatric Infectious Diseases',
	'event.category.pediatric-neurology': 'Pediatric Neurology',
	'event.category.pediatric-respiralogy': 'Pediatric Respiralogy',
	'event.category.pediatric-urology': 'Pediatric Urology',
	'event.category.pediatrics': 'Pediatrics',
	'event.category.perianesthesia': 'Perianesthesia',
	'event.category.perinatal-medicine': 'Perinatal Medicine',
	'event.category.perioperative': 'Perioperative',
	'event.category.personal-injury-management-assessment': 'Personal Injury Management Assessment',
	'event.category.personal-support-workers': 'Personal Support Workers',
	'event.category.pharmaceutical': 'Pharmaceutical',
	'event.category.pharmacology': 'Pharmacology',
	'event.category.pharmacy': 'Pharmacy',
	'event.category.phlebology': 'Phlebology',
	'event.category.physical-medicine-and-rehabilitation': 'Physical Medicine and Rehabilitation',
	'event.category.physical-therapy': 'Physical Therapy',
	'event.category.physiology': 'Physiology',
	'event.category.physiotherapy': 'Physiotherapy',
	'event.category.plastic-and-reconstructive-surgical': 'Plastic and reconstructive surgical',
	'event.category.plastic-surgery': 'Plastic Surgery',
	'event.category.population-public-health-health-promotion': 'Population/Public Health/Health Promotion',
	'event.category.post-traumatic-stress-disorder': 'Post Traumatic Stress Disorder',
	'event.category.practice-clinic-administrator': 'Practice/Clinic Administrator',
	'event.category.practice-clinic-manager': 'Practice/Clinic Manager',
	'event.category.prenatal-care': 'Prenatal Care',
	'event.category.presentations-workshops': 'Presentations/Workshops',
	'event.category.preventive-medicine': 'Preventive Medicine',
	'event.category.primary-care': 'Primary Care',
	'event.category.private-duty': 'Private duty',
	'event.category.proctology': 'Proctology',
	'event.category.procurement': 'Procurement',
	'event.category.professional-relations': 'Professional Relations',
	'event.category.professional-standards': 'Professional Standards',
	'event.category.program-planning-evaluation': 'Program Planning/Evaluation',
	'event.category.project-management': 'Project Management',
	'event.category.psychiatric-or-mental-health': 'Psychiatric or mental health',
	'event.category.psychiatry': 'Psychiatry',
	'event.category.psychiatry-sequelae-of-trauma': 'Psychiatry Sequelae Of Trauma',
	'event.category.psycho-pharmacology': 'Psycho Pharmacology',
	'event.category.psychoanalytic-and-psychotherapy': 'Psychoanalytic and Psychotherapy',
	'event.category.psychodynamic-psychotherapy': 'Psychodynamic/Psychotherapy',
	'event.category.psychological-medicine': 'Psychological Medicine',
	'event.category.psychotherapy': 'Psychotherapy',
	'event.category.public-health': 'Public Health',
	'event.category.public-policy': 'Public Policy',
	'event.category.public-policy-standard-development': 'Public Policy & Standard Development',
	'event.category.public-relations': 'Public Relations',
	'event.category.pulmonary': 'Pulmonary',
	'event.category.quality-assurance-benchmarks': 'Quality Assurance/Benchmarks',
	'event.category.quality-improvement': 'Quality improvement',
	'event.category.radiation-oncology': 'Radiation Oncology',
	'event.category.radiation-therapy': 'Radiation Therapy',
	'event.category.radiology': 'Radiology',
	'event.category.radiology-diagnostic': 'Radiology, Diagnostic',
	'event.category.radiology-therepeutic': 'Radiology, Therepeutic',
	'event.category.receptionist-front-desk': 'Receptionist/Front Desk',
	'event.category.recipe-food-product-development': 'Recipe/Food Product Development',
	'event.category.refractive-cataract-surgery': 'Refractive Cataract Surgery',
	'event.category.regulatory-affairs-position': 'Regulatory Affairs Position',
	'event.category.regulatory-compliance': 'Regulatory Compliance',
	'event.category.rehabilitation': 'Rehabilitation',
	'event.category.renal': 'Renal',
	'event.category.renal-dialysis': 'Renal dialysis',
	'event.category.renal-pathology': 'Renal Pathology',
	'event.category.reproductive-endocrinology-and-fertility': 'Reproductive Endocrinology and Fertility',
	'event.category.research': 'Research',
	'event.category.research-facilities': 'Research Facilities',
	'event.category.research-pharmacists': 'Research Pharmacists',
	'event.category.resources-and-policy-making': 'Resources and Policy Making',
	'event.category.respiratory-disease': 'Respiratory Disease',
	'event.category.respiratory-medicine': 'Respiratory Medicine',
	'event.category.respiratory-therapy': 'Respiratory Therapy',
	'event.category.respirology': 'Respirology',
	'event.category.rheumatology': 'Rheumatology',
	'event.category.sales-and-promotion': 'Sales and Promotion',
	'event.category.self-employment': 'Self Employment',
	'event.category.sexual-assault': 'Sexual Assault',
	'event.category.sexual-dysfunction': 'Sexual Dysfunction',
	'event.category.sexual-medicine': 'Sexual Medicine',
	'event.category.skin-med': 'Skin Med',
	'event.category.sleep-disorders': 'Sleep Disorders',
	'event.category.sleep-medicine': 'Sleep Medicine',
	'event.category.social-services': 'Social Services',
	'event.category.social-work': 'Social Work',
	'event.category.specialty-medicine': 'Specialty Medicine',
	'event.category.spinal-cord-injury': 'Spinal Cord Injury',
	'event.category.spinal-deformity-surgery': 'Spinal Deformity Surgery',
	'event.category.spine-surgery': 'Spine Surgery',
	'event.category.sports-medicine': 'Sports Medicine',
	'event.category.stakeholder-management': 'Stakeholder Management',
	'event.category.stress': 'Stress',
	'event.category.stroke': 'Stroke',
	'event.category.sub-acute': 'Sub-acute',
	'event.category.substance-abuse': 'Substance abuse',
	'event.category.supply-management': 'Supply Management',
	'event.category.surgical-oncology': 'Surgical Oncology',
	'event.category.survey-questionnaire-development': 'Survey/Questionnaire Development',
	'event.category.systems-analysis': 'Systems Analysis',
	'event.category.teaching-university-or-college': 'Teaching at University or College',
	'event.category.team-program-management': 'Team/Program Management',
	'event.category.tele-medicine': 'Tele-medicine',
	'event.category.telehealth': 'Telehealth',
	'event.category.telemetry': 'Telemetry',
	'event.category.telephone-triage': 'Telephone triage',
	'event.category.therapeutic-radiology': 'Therapeutic Radiology',
	'event.category.therapy-wellness-clinic': 'Therapy / Wellness Clinic',
	'event.category.thoracic-surgery': 'Thoracic Surgery',
	'event.category.thromboembolism': 'Thromboembolism',
	'event.category.toxicology': 'Toxicology',
	'event.category.transcriptionists': 'Transcriptionists',
	'event.category.transfusion-medicine': 'Transfusion Medicine',
	'event.category.transplantation': 'Transplantation',
	'event.category.travel-medicine': 'Travel Medicine',
	'event.category.urological-oncology': 'Urological Oncology',
	'event.category.urology': 'Urology',
	'event.category.utilization-management': 'Utilization management',
	'event.category.varicose-veins': 'Varicose Veins',
	'event.category.vascular': 'Vascular',
	'event.category.vascular-surgery': 'Vascular Surgery',
	'event.category.vision-eye-problems': 'Vision and Eye Problems',
	'event.category.volunteer-management': 'Volunteer Management',
	'event.category.volunteer-programming': 'Volunteer Programming',
	'event.category.walk-in-care': 'Walk in care',
	'event.category.weight-management': 'Weight Management',
	'event.category.womens-mental-health': 'Womens Mental Health',
	'event.category.work-injuries': 'Work Injuries',
	'event.category.wound-care': 'Wound Care',
	'event.category.writing-resource-development-for-consumers': 'Writing/Resource Development for Consumers',
	'event.category.writing-resource-development-for-professionals': 'Writing/Resource Development for Professionals',
};

export const EVENT_API_STRINGS_TO_TOPIC_KEY = Object.fromEntries(Object.entries(EVENT_TOPIC_KEYS_TO_API_STRING).map(([a, b]) => [b, a]));

export const EVENT_TOPIC_KEYS = Object.keys(EVENT_TOPIC_KEYS_TO_API_STRING);
